// extracted by mini-css-extract-plugin
export default {"warrantiesTable":"WarrantiesTable_warrantiesTable__G1akl","canceledWarrantyRow":"WarrantiesTable_canceledWarrantyRow__4vgo+"};